import { makeStyles } from 'tss-react/mui'
const useStyles = makeStyles()(() => ({
  rootContainer: {
    backgroundSize: 'cover',
    height: '600px',
    '& .mui-style-ynxs4f-rootContainer': {
      paddingTop: '70px',
    },
  },
  zenRootContainer: {
    background: 'none',
  },
}))

export default useStyles
